import { render } from "./WireframesPage.vue?vue&type=template&id=ea3a8d34&scoped=true"
import script from "./WireframesPage.vue?vue&type=script&lang=js"
export * from "./WireframesPage.vue?vue&type=script&lang=js"

import "./WireframesPage.vue?vue&type=style&index=0&id=ea3a8d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3a8d34"]])

export default __exports__